export default {
    emojiList:["[微笑]", "[撇嘴]", "[色]", "[发呆]", "[得意]", "[流泪]", "[害羞]","[闭嘴]", "[睡]", "[大哭]", "[尴尬]", "[发怒]", "[调皮]", "[呲牙]","[惊讶]", "[难过]",
        "[囧]", "[抓狂]", "[吐]", "[偷笑]","[可爱]", "[白眼]", "[傲慢]", "[困]", "[惊恐]", "[流汗]", "[憨笑]","[大兵]", "[奋斗]", "[咒骂]", "[疑问]", "[嘘]",
        "[晕]", "[衰]","[骷髅]", "[敲打]", "[再见]", "[擦汗]", "[抠鼻]", "[鼓掌]",
        "[坏笑]", "[左哼哼]", "[右哼哼]", "[哈欠]", "[鄙视]", "[委屈]", "[快哭了]","[阴险]",
        "[亲亲]", "[可怜]", "[菜刀]", "[西瓜]", "[啤酒]", "[咖啡]", "[猪头]","[玫瑰]","[凋谢]", "[嘴唇]",
"[爱心]",
"[心碎]",
"[蛋糕]",
"[炸弹]",
"[便便]",
"[月亮]",
"[太阳]",
"[拥抱]",
"[强]",
"[弱]",
"[握手]",
"[胜利]",
"[抱拳]",
"[勾引]",
"[拳头]",
"[OK]",
"[跳跳]",
"[发抖]",
"[怄火]",
"[转圈]",
"[嘿哈]",
"[捂脸]",
"[奸笑]",
"[机智]",
"[皱眉]",
"[耶]",
"[茶]",
"[红包]",
"[蜡烛]"],
    wxToHan:{
        "/::~": "[撇嘴]",
        "/::B": "[色]",
        "/::|": "[发呆]",
        "/:8-)": "[得意]",
        "/::<": "[流泪]",
        "/::$": "[害羞]",
        "/::X": "[闭嘴]",
        "/::Z":"[睡]",
        "/::'(":"[大哭]",
        "/::-|":"[尴尬]",
        "/::@":"[发怒]",
        "/::P":"[调皮]",
        "/::D":"[呲牙]",
        "/::O":"[惊讶]",
        "/::(":"[难过]",
        /*"[囧]":"[囧]",*/
        "/::Q":"[抓狂]",
        "/::T":"[吐]",
        "/:,@P":"[偷笑]",
        "/:,@-D":"[可爱]",
        "/::d":"[白眼]",
        "/:,@o":"[傲慢]",
        "/:|-)":"[困]",
        "/::!": "[惊恐]",
        "/::L": "[流汗]",
        "/::>":"[憨笑]",
        //"[大兵]":"[大兵]",
        "/:,@f":"[奋斗]",
        "/::-S":"[咒骂]",
        "/:?":"[疑问]",
        "/:,@x":"[嘘]",
        "/:,@@":"[晕]",//        /:handclap
        "/:,@!":"[衰]",
        "/:!!!":"[骷髅]",
        "/:xx":"[敲打]",
        "/:bye":"[再见]",
        "/:wipe":"[擦汗]",
        "/:dig":"[抠鼻]",
        "/:handclap":"[鼓掌]",
        "/:B-)":"[坏笑]", //
        "/:<@":"[左哼哼]",
        "/:@>":"[右哼哼]",
        "/::-O":"[哈欠]",
        "/:>-|":"[鄙视]",
        "/:P-(":"[委屈]",
        "/::'|":"[快哭了]",
        "/:X-)":"[阴险]",
        "/::*":"[亲亲]",
        "/:8*":"[可怜]",
        "/:pd":"[菜刀]",
        "/:":"[西瓜]",
        "/:beer":"[啤酒]",
        "/:coffee":"[咖啡]",
        "/:pig":"[猪头]",
        "/:rose":"[玫瑰]",
        "/:fade":"[凋谢]",
        "/:showlove":"[嘴唇]",
        "/:heart":"[爱心]",
        "/:break":"[心碎]",
        "/:cake":"[蛋糕]",
        "/:bome":"[炸弹]",
        "/:shit":"[便便]",
        "/:moon":"[月亮]",
        "/:sun":"[太阳]",
        "/:hug":"[拥抱]",
        "/:strong": "[强]",
        "/:weak":"[弱]",
        "/:share":"[握手]",
        "/:v":"[胜利]",
        "/:@)":"[抱拳]",
        "/:jj":"[勾引]",
        "/:@@":"[拳头]",
        "/:ok":"[OK]",
        "/:jump":"[跳跳]",
        "/:shake":"[发抖]",
        "/:circle":"[转圈]"
    },
    showEmojiData: {
        "[微笑]": "<img src='/static/emojicons/ace_emoji_1.png' align='absmiddle' class='emoji-icon'>",
        "[撇嘴]": "<img src='/static/emojicons/ace_emoji_2.png' align='absmiddle' class='emoji-icon'>",
        "[色]": "<img src='/static/emojicons/ace_emoji_3.png' align='absmiddle' class='emoji-icon'>",
        "[发呆]": "<img src='/static/emojicons/ace_emoji_4.png' align='absmiddle' class='emoji-icon'>",
        "[得意]": "<img src='/static/emojicons/ace_emoji_5.png' align='absmiddle' class='emoji-icon'>",
        "[流泪]": "<img src='/static/emojicons/ace_emoji_6.png' align='absmiddle' class='emoji-icon'>",
        "[害羞]": "<img src='/static/emojicons/ace_emoji_7.png' align='absmiddle' class='emoji-icon'>",
        "[闭嘴]": "<img src='/static/emojicons/ace_emoji_8.png' align='absmiddle' class='emoji-icon'>",
        "[睡]": "<img src='/static/emojicons/ace_emoji_9.png' align='absmiddle' class='emoji-icon'>",
        "[大哭]": "<img src='/static/emojicons/ace_emoji_10.png' align='absmiddle' class='emoji-icon'>",
        "[尴尬]": "<img src='/static/emojicons/ace_emoji_11.png' align='absmiddle' class='emoji-icon'>",
        "[发怒]": "<img src='/static/emojicons/ace_emoji_12.png' align='absmiddle' class='emoji-icon'>",
        "[调皮]": "<img src='/static/emojicons/ace_emoji_13.png' align='absmiddle' class='emoji-icon'>",
        "[呲牙]": "<img src='/static/emojicons/ace_emoji_14.png' align='absmiddle' class='emoji-icon'>",
        "[惊讶]": "<img src='/static/emojicons/ace_emoji_15.png' align='absmiddle' class='emoji-icon'>",
        "[难过]": "<img src='/static/emojicons/ace_emoji_16.png' align='absmiddle' class='emoji-icon'>",
        "[酷]": "<img src='/static/emojicons/ace_emoji_17.png' align='absmiddle' class='emoji-icon'>",
        "[冷汗]": "<img src='/static/emojicons/ace_emoji_18.png' align='absmiddle' class='emoji-icon'>",
        "[抓狂]": "<img src='/static/emojicons/ace_emoji_19.png' align='absmiddle' class='emoji-icon'>",
        "[吐]": "<img src='/static/emojicons/ace_emoji_20.png' align='absmiddle' class='emoji-icon'>",
        "[偷笑]": "<img src='/static/emojicons/ace_emoji_21.png' align='absmiddle' class='emoji-icon'>",
        "[愉快]": "<img src='/static/emojicons/ace_emoji_22.png' align='absmiddle' class='emoji-icon'>",
        "[白眼]": "<img src='/static/emojicons/ace_emoji_23.png' align='absmiddle' class='emoji-icon'>",
        "[傲慢]": "<img src='/static/emojicons/ace_emoji_24.png' align='absmiddle' class='emoji-icon'>",
        "[饥饿]": "<img src='/static/emojicons/ace_emoji_25.png' align='absmiddle' class='emoji-icon'>",
        "[困]": "<img src='/static/emojicons/ace_emoji_26.png' align='absmiddle' class='emoji-icon'>",
        "[惊恐]": "<img src='/static/emojicons/ace_emoji_27.png' align='absmiddle' class='emoji-icon'>",
        "[流汗]": "<img src='/static/emojicons/ace_emoji_28.png' align='absmiddle' class='emoji-icon'>",
        "[憨笑]": "<img src='/static/emojicons/ace_emoji_29.png' align='absmiddle' class='emoji-icon'>",
        "[悠闲]": "<img src='/static/emojicons/ace_emoji_30.png' align='absmiddle' class='emoji-icon'>",
        "[奋斗]": "<img src='/static/emojicons/ace_emoji_31.png' align='absmiddle' class='emoji-icon'>",
        "[咒骂]": "<img src='/static/emojicons/ace_emoji_32.png' align='absmiddle' class='emoji-icon'>",
        "[疑问]": "<img src='/static/emojicons/ace_emoji_33.png' align='absmiddle' class='emoji-icon'>",
        "[嘘]": "<img src='/static/emojicons/ace_emoji_34.png' align='absmiddle' class='emoji-icon'>",
        "[晕]": "<img src='/static/emojicons/ace_emoji_35.png' align='absmiddle' class='emoji-icon'>",
        "[疯了]": "<img src='/static/emojicons/ace_emoji_36.png' align='absmiddle' class='emoji-icon'>",
        "[衰]": "<img src='/static/emojicons/ace_emoji_37.png' align='absmiddle' class='emoji-icon'>",
        "[骷髅]": "<img src='/static/emojicons/ace_emoji_38.png' align='absmiddle' class='emoji-icon'>",
        "[敲打]": "<img src='/static/emojicons/ace_emoji_39.png' align='absmiddle' class='emoji-icon'>",
        "[再见]": "<img src='/static/emojicons/ace_emoji_40.png' align='absmiddle' class='emoji-icon'>",
        "[擦汗]": "<img src='/static/emojicons/ace_emoji_41.png' align='absmiddle' class='emoji-icon'>",
        "[抠鼻]": "<img src='/static/emojicons/ace_emoji_42.png' align='absmiddle' class='emoji-icon'>",
        "[鼓掌]": "<img src='/static/emojicons/ace_emoji_43.png' align='absmiddle' class='emoji-icon'>",
        "[糗大了]": "<img src='/static/emojicons/ace_emoji_44.png' align='absmiddle' class='emoji-icon'>",
        "[坏笑]": "<img src='/static/emojicons/ace_emoji_45.png' align='absmiddle' class='emoji-icon'>",
        "[左哼哼]": "<img src='/static/emojicons/ace_emoji_46.png' align='absmiddle' class='emoji-icon'>",
        "[右哼哼]": "<img src='/static/emojicons/ace_emoji_47.png' align='absmiddle' class='emoji-icon'>",
        "[哈欠]": "<img src='/static/emojicons/ace_emoji_48.png' align='absmiddle' class='emoji-icon'>",
        "[鄙视]": "<img src='/static/emojicons/ace_emoji_49.png' align='absmiddle' class='emoji-icon'>",
        "[委屈]": "<img src='/static/emojicons/ace_emoji_50.png' align='absmiddle' class='emoji-icon'>",
        "[快哭了]": "<img src='/static/emojicons/ace_emoji_51.png' align='absmiddle' class='emoji-icon'>",
        "[阴险]": "<img src='/static/emojicons/ace_emoji_52.png' align='absmiddle' class='emoji-icon'>",
        "[亲亲]": "<img src='/static/emojicons/ace_emoji_53.png' align='absmiddle' class='emoji-icon'>",
        "[吓]": "<img src='/static/emojicons/ace_emoji_54.png' align='absmiddle' class='emoji-icon'>",
        "[可怜]": "<img src='/static/emojicons/ace_emoji_55.png' align='absmiddle' class='emoji-icon'>",
        "[菜刀]": "<img src='/static/emojicons/ace_emoji_56.png' align='absmiddle' class='emoji-icon'>",
        "[西瓜]": "<img src='/static/emojicons/ace_emoji_57.png' align='absmiddle' class='emoji-icon'>",
        "[啤酒]": "<img src='/static/emojicons/ace_emoji_58.png' align='absmiddle' class='emoji-icon'>",
        "[篮球]": "<img src='/static/emojicons/ace_emoji_59.png' align='absmiddle' class='emoji-icon'>",
        "[乒乓]": "<img src='/static/emojicons/ace_emoji_60.png' align='absmiddle' class='emoji-icon'>",
        "[笑脸]": "<img src='/static/emojicons/emoji2/1.png' align='absmiddle' class='emoji-icon'>",
        "[哭笑]": "<img src='/static/emojicons/emoji2/2.png' align='absmiddle' class='emoji-icon'>",
        "[呲牙笑]": "<img src='/static/emojicons/emoji2/3.png' align='absmiddle' class='emoji-icon'>",
        "[开心]": "<img src='/static/emojicons/emoji2/4.png' align='absmiddle' class='emoji-icon'>",
        "[大笑]": "<img src='/static/emojicons/emoji2/5.png' align='absmiddle' class='emoji-icon'>",
        "[笑晕]": "<img src='/static/emojicons/emoji2/6.png' align='absmiddle' class='emoji-icon'>",
        "[单眼笑]": "<img src='/static/emojicons/emoji2/7.png' align='absmiddle' class='emoji-icon'>",
        "[可爱]": "<img src='/static/emojicons/emoji2/8.png' align='absmiddle' class='emoji-icon'>",
        "[吐舌]": "<img src='/static/emojicons/emoji2/9.png' align='absmiddle' class='emoji-icon'>",
        "[邪恶]": "<img src='/static/emojicons/emoji2/10.png' align='absmiddle' class='emoji-icon'>",
        "[墨镜酷]": "<img src='/static/emojicons/emoji2/11.png' align='absmiddle' class='emoji-icon'>",
        "[自信]": "<img src='/static/emojicons/emoji2/12.png' align='absmiddle' class='emoji-icon'>",
        "[喜欢]": "<img src='/static/emojicons/emoji2/13.png' align='absmiddle' class='emoji-icon'>",
        "[好吧]": "<img src='/static/emojicons/emoji2/14.png' align='absmiddle' class='emoji-icon'>",
        "[无语]": "<img src='/static/emojicons/emoji2/15.png' align='absmiddle' class='emoji-icon'>",
        "[无言]": "<img src='/static/emojicons/emoji2/16.png' align='absmiddle' class='emoji-icon'>",
        "[眯眼汗]": "<img src='/static/emojicons/emoji2/18.png' align='absmiddle' class='emoji-icon'>",
        "[失落]": "<img src='/static/emojicons/emoji2/19.png' align='absmiddle' class='emoji-icon'>",
        "[不屑]": "<img src='/static/emojicons/emoji2/20.png' align='absmiddle' class='emoji-icon'>",
        "[慌张]": "<img src='/static/emojicons/emoji2/21.png' align='absmiddle' class='emoji-icon'>",
        "[圆眼亲]": "<img src='/static/emojicons/emoji2/22.png' align='absmiddle' class='emoji-icon'>",
        "[示爱]": "<img src='/static/emojicons/emoji2/23.png' align='absmiddle' class='emoji-icon'>",
        "[眯眼亲]": "<img src='/static/emojicons/emoji2/24.png' align='absmiddle' class='emoji-icon'>",
        "[圆眼吐舌]": "<img src='/static/emojicons/emoji2/25.png' align='absmiddle' class='emoji-icon'>",
        "[单眼吐舌]": "<img src='/static/emojicons/emoji2/26.png' align='absmiddle' class='emoji-icon'>",
        "[疯狂]": "<img src='/static/emojicons/emoji2/27.png' align='absmiddle' class='emoji-icon'>",
        "[低落]": "<img src='/static/emojicons/emoji2/28.png' align='absmiddle' class='emoji-icon'>",
        "[不开心]": "<img src='/static/emojicons/emoji2/29.png' align='absmiddle' class='emoji-icon'>",
        "[怒]": "<img src='/static/emojicons/emoji2/30.png' align='absmiddle' class='emoji-icon'>",
        "[哼]": "<img src='/static/emojicons/emoji2/31.png' align='absmiddle' class='emoji-icon'>",
        "[不要]": "<img src='/static/emojicons/emoji2/32.png' align='absmiddle' class='emoji-icon'>",
        "[汗颜]": "<img src='/static/emojicons/emoji2/33.png' align='absmiddle' class='emoji-icon'>",
        "[啊]": "<img src='/static/emojicons/emoji2/34.png' align='absmiddle' class='emoji-icon'>",
        "[瞪眼]": "<img src='/static/emojicons/emoji2/35.png' align='absmiddle' class='emoji-icon'>",
        "[呆]": "<img src='/static/emojicons/emoji2/36.png' align='absmiddle' class='emoji-icon'>",
        "[哦]": "<img src='/static/emojicons/emoji2/37.png' align='absmiddle' class='emoji-icon'>",
        "[吓人]": "<img src='/static/emojicons/emoji2/38.png' align='absmiddle' class='emoji-icon'>",
        "[悲]": "<img src='/static/emojicons/emoji2/39.png' align='absmiddle' class='emoji-icon'>",
        "[大悲]": "<img src='/static/emojicons/emoji2/40.png' align='absmiddle' class='emoji-icon'>",
        "[戴口罩]": "<img src='/static/emojicons/emoji2/41.png' align='absmiddle' class='emoji-icon'>",
        "[惊汗]": "<img src='/static/emojicons/emoji2/42.png' align='absmiddle' class='emoji-icon'>",
        "[没眼看]": "<img src='/static/emojicons/emoji2/43.png' align='absmiddle' class='emoji-icon'>",
        "[恐惧]": "<img src='/static/emojicons/emoji2/44.png' align='absmiddle' class='emoji-icon'>",
        "[两行泪]": "<img src='/static/emojicons/emoji2/45.png' align='absmiddle' class='emoji-icon'>",
        "[呵呵]": "<img src='/static/emojicons/emoji2/46.png' align='absmiddle' class='emoji-icon'>",
        "[嘻嘻]": "<img src='/static/emojicons/emoji2/47.png' align='absmiddle' class='emoji-icon'>",
        "[瞌睡]": "<img src='/static/emojicons/emoji2/48.png' align='absmiddle' class='emoji-icon'>",
        "[睡觉]": "<img src='/static/emojicons/emoji2/49.png' align='absmiddle' class='emoji-icon'>",
        "[笑汗]": "<img src='/static/emojicons/emoji2/50.png' align='absmiddle' class='emoji-icon'>",
        "[合掌]": "<img src='/static/emojicons/emoji2/51.png' align='absmiddle' class='emoji-icon'>",
        "[礼炮]": "<img src='/static/emojicons/emoji2/52.png' align='absmiddle' class='emoji-icon'>",
        "[礼物]": "<img src='/static/emojicons/emoji2/53.png' align='absmiddle' class='emoji-icon'>",
        "[出汗]": "<img src='/static/emojicons/emoji2/54.png' align='absmiddle' class='emoji-icon'>",
        "[100分]": "<img src='/static/emojicons/emoji2/55.png' align='absmiddle' class='emoji-icon'>",
        "[音符]": "<img src='/static/emojicons/emoji2/56.png' align='absmiddle' class='emoji-icon'>",
        "[溜了]": "<img src='/static/emojicons/emoji2/57.png' align='absmiddle' class='emoji-icon'>",
        "[唇印]": "<img src='/static/emojicons/emoji2/58.png' align='absmiddle' class='emoji-icon'>",
        "[嚣张]": "<img src='/static/emojicons/emoji2/59.png' align='absmiddle' class='emoji-icon'>",
        "[zzz]": "<img src='/static/emojicons/emoji2/60.png' align='absmiddle' class='emoji-icon'>",
        "[囧]": "<img src='/static/emojicons/ex/jiong.png' align='absmiddle' class='emoji-icon'>",
        "[大兵]": "<img src='/static/emojicons/ex/dabing.png' align='absmiddle' class='emoji-icon'>",
        "[咖啡]": "<img src='/static/emojicons/ex/kafei.png' align='absmiddle' class='emoji-icon'>",
        "[猪头]": "<img src='/static/emojicons/ex/zhutou.png' align='absmiddle' class='emoji-icon'>",
        "[玫瑰]": "<img src='/static/emojicons/ex/meigui.png' align='absmiddle' class='emoji-icon'>",
        "[凋谢]": "<img src='/static/emojicons/ex/diaoxie.png' align='absmiddle' class='emoji-icon'>",
        "[嘴唇]": "<img src='/static/emojicons/ex/zuichen.png' align='absmiddle' class='emoji-icon'>",
        "[爱心]": "<img src='/static/emojicons/ex/aixin.png' align='absmiddle' class='emoji-icon'>",
        "[心碎]": "<img src='/static/emojicons/ex/xinshui.png' align='absmiddle' class='emoji-icon'>",
        "[蛋糕]": "<img src='/static/emojicons/ex/dangao.png' align='absmiddle' class='emoji-icon'>",
        "[炸弹]": "<img src='/static/emojicons/ex/zhadan.png' align='absmiddle' class='emoji-icon'>",
        "[便便]": "<img src='/static/emojicons/ex/bianbian.png' align='absmiddle' class='emoji-icon'>",
        "[月亮]": "<img src='/static/emojicons/ex/yueliang.png' align='absmiddle' class='emoji-icon'>",
        "[太阳]": "<img src='/static/emojicons/ex/taiyang.png' align='absmiddle' class='emoji-icon'>",
        "[拥抱]": "<img src='/static/emojicons/ex/yongbao.png' align='absmiddle' class='emoji-icon'>",
        "[强]": "<img src='/static/emojicons/ex/qiang.png' align='absmiddle' class='emoji-icon'>",
        "[弱]": "<img src='/static/emojicons/ex/ruo.png' align='absmiddle' class='emoji-icon'>",
        "[握手]": "<img src='/static/emojicons/ex/woshou.png' align='absmiddle' class='emoji-icon'>",
        "[胜利]": "<img src='/static/emojicons/ex/shengli.png' align='absmiddle' class='emoji-icon'>",
        "[抱拳]": "<img src='/static/emojicons/ex/baoquan.png' align='absmiddle' class='emoji-icon'>",
        "[勾引]": "<img src='/static/emojicons/ex/gouyin.png' align='absmiddle' class='emoji-icon'>",
        "[拳头]": "<img src='/static/emojicons/ex/woquan.png' align='absmiddle' class='emoji-icon'>",
        "[OK]": "<img src='/static/emojicons/ex/ok.png' align='absmiddle' class='emoji-icon'>",
        "[跳跳]": "<img src='/static/emojicons/ex/tiaotiao.png' align='absmiddle' class='emoji-icon'>",
        "[发抖]": "<img src='/static/emojicons/ex/fadou.png' align='absmiddle' class='emoji-icon'>",
        "[怄火]": "<img src='/static/emojicons/ex/ouhuo.png' align='absmiddle' class='emoji-icon'>",
        "[转圈]": "<img src='/static/emojicons/ex/zhuanquan.png' align='absmiddle' class='emoji-icon'>",
        "[嘿哈]": "<img src='/static/emojicons/ex/heiha.png' align='absmiddle' class='emoji-icon'>",
        "[捂脸]": "<img src='/static/emojicons/ex/wulian.png' align='absmiddle' class='emoji-icon'>",
        "[奸笑]": "<img src='/static/emojicons/ex/jianxiao.png' align='absmiddle' class='emoji-icon'>",
        "[机智]": "<img src='/static/emojicons/ex/jizhi.png' align='absmiddle' class='emoji-icon'>",
        "[皱眉]": "<img src='/static/emojicons/ex/zhoumei.png' align='absmiddle' class='emoji-icon'>",
        "[耶]": "<img src='/static/emojicons/ex/ye.png' align='absmiddle' class='emoji-icon'>",
        "[茶]": "<img src='/static/emojicons/ex/cha.png' align='absmiddle' class='emoji-icon'>",
        "[红包]": "<img src='/static/emojicons/ex/hongbao.png' align='absmiddle' class='emoji-icon'>",
        "[蜡烛]": "<img src='/static/emojicons/ex/lazhu.png' align='absmiddle' class='emoji-icon'>",
    }
}


// WEBPACK FOOTER //
// ./src/api/emojson.js